export default __webpack_public_path__ + "static/media/youtubeStopIcon.fb902a51.svg";